import React, { useState } from 'react';
import { auth } from '../api';
import { B } from '../constants';
import { GBWordmark } from '../components/Logo';
import Input from '../components/ui/Input';

const backgrounds = [
  'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1200&q=80',
];

export default function ForgotPasswordScreen() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const data = await auth.forgotPassword(email.trim());
      setMessage(data.message || 'If that email exists, a reset link has been sent');
    } catch (err) {
      setError(err.message || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${backgrounds[0]}) center/cover`, position: 'relative' }}>
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.65)' }} />
      
      <div style={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: 420, padding: '40px 32px', background: 'rgba(255,255,255,0.08)', backdropFilter: 'blur(20px)', borderRadius: 24, border: '1px solid rgba(255,255,255,0.1)', margin: 20 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <GBWordmark size="md" />
          <h1 style={{ color: 'white', fontSize: 24, marginTop: 24, fontFamily: "'Playfair Display',serif" }}>Reset Password</h1>
          <p style={{ color: 'rgba(255,255,255,0.6)', marginTop: 8, fontSize: 14 }}>
            Enter your email and we'll send you a reset link
          </p>
        </div>

        {message && (
          <div style={{ background: 'rgba(26,107,74,0.2)', border: '1px solid #1a6b4a', borderRadius: 12, padding: 14, marginBottom: 20, color: '#4ade80', fontSize: 14, textAlign: 'center' }}>
            {message}
          </div>
        )}

        {error && (
          <div style={{ background: 'rgba(220,53,69,0.2)', border: '1px solid #dc3545', borderRadius: 12, padding: 14, marginBottom: 20, color: '#f87171', fontSize: 14, textAlign: 'center' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', marginBottom: 8, color: 'rgba(255,255,255,0.7)', fontSize: 12, fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase' }}>
              Email Address
            </label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              style={{
                width: '100%',
                background: 'rgba(255,255,255,0.06)',
                border: '1.5px solid rgba(255,255,255,0.1)',
                borderRadius: 12,
                padding: '14px 16px',
                color: 'white',
                fontSize: 14,
                fontFamily: "'Montserrat',sans-serif",
                outline: 'none',
                boxSizing: 'border-box',
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              background: loading ? '#333' : `linear-gradient(135deg,${B.forest},#22a06b)`,
              color: 'white',
              border: 'none',
              padding: '14px 0',
              borderRadius: 12,
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: 14,
              fontWeight: 700,
              fontFamily: "'Montserrat',sans-serif",
              boxShadow: loading ? 'none' : `0 4px 20px rgba(26,107,74,0.4)`,
            }}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 24, color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>
          Remember your password?{' '}
          <a href="/login" style={{ color: B.mint, cursor: 'pointer', fontWeight: 700, textDecoration: 'none' }}>
            Sign in
          </a>
        </p>
      </div>
    </div>
  );
}